import React, { useEffect, useState } from 'react';
import { Modal, Spin, message, Tag, Button } from 'antd';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import './index.scss';

interface SimInfo {
  standard: string;
  band: string;
  communityId: string;
  stationId: string;
  rsrp: number;
  sinr: number;
  dailyUpload: number;
  dailyDownload: number;
  onlineStatus: 0 | 1 | 2;
  mainCard: 'MAIN' | 'SECOND';
}

interface Props {
  visible: boolean;
  vehicleName: string;
  onClose: () => void;
}

const SimInfoModal: React.FC<Props> = ({ visible, vehicleName, onClose }) => {
  const [simInfoList, setSimInfoList] = useState<SimInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (visible) {
      fetchSimInfo();
    }
  }, [visible]);
  const fetchSimInfo = async () => {
    if (!vehicleName) {
      message.error('无法获取车辆信息');
      return;
    }
    setLoading(true);
    try {
      const res = await request({
        method: 'POST',
        path: '/monitor/web/cockpit/getVehicleSimInfo',
        body: {
          vehicleName: vehicleName,
        },
      });

      if (res.code === HttpStatusCode.Success) {
        setSimInfoList(res.data || []);
      } else {
        message.error(res.message || '获取SIM卡信息失败');
      }
    } catch (error) {
      message.error('获取SIM卡信息失败');
    } finally {
      setLoading(false);
    }
  };

  const renderInfoItem = (label: string, value: React.ReactNode) => (
    <div className="info-item" key={label}>
      <span className="info-label">{label}</span>
      <span className="info-value">{value}</span>
    </div>
  );

  return (
    <Modal
      title="网络信息"
      open={visible}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={fetchSimInfo}>
          刷新
        </Button>
      }
      width={800}
      centered
    >
      <Spin spinning={loading}>
        <div className="sim-info-container">
          {simInfoList.map((sim, index) => (
            <div className="sim-card" key={index}>
              <div className="sim-card-header">
                <span className="sim-title">
                  {index === 0 ? 'SIM1' : 'SIM2'}
                </span>
                <Tag color={sim.onlineStatus === 2 ? 'success' : 'default'}>
                  {sim.onlineStatus === 2
                    ? '在线'
                    : sim.onlineStatus === 1
                    ? '离线'
                    : '未知'}
                </Tag>
                <Tag color={sim.mainCard ? '#f50' : '#2db7f5'}>
                  {sim.mainCard ? '主卡' : '副卡'}
                </Tag>
              </div>
              <div className="sim-card-body">
                {renderInfoItem('制式', sim.standard)}
                {renderInfoItem('频段', sim.band)}
                {renderInfoItem('小区 ID', sim.communityId)}
                {renderInfoItem('基站 ID', sim.stationId)}
                {renderInfoItem('RSRP', `${sim.rsrp.toFixed(2)} dBm`)}
                {renderInfoItem('SINR', `${sim.sinr.toFixed(2)} dB`)}
                {renderInfoItem(
                  '当日上传流量',
                  `${sim.dailyUpload.toFixed(2)} GB`
                )}
                {renderInfoItem(
                  '当日下载流量',
                  `${sim.dailyDownload.toFixed(2)} GB`
                )}
              </div>
            </div>
          ))}
        </div>
      </Spin>
    </Modal>
  );
};

export default React.memo(SimInfoModal);
